import script from "./DefaultFallback.vue?vue&type=script&lang=js"
export * from "./DefaultFallback.vue?vue&type=script&lang=js"

import "./DefaultFallback.vue?vue&type=style&index=0&id=65d89590&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-65d89590"]])

export default __exports__